"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Title = _interopRequireDefault(require("../components/media/models/Title"));

var _TitleCollection = _interopRequireDefault(require("../components/media/models/TitleCollection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// This is a replacement for PatronMediaItemsModel (ecmascript\models\patron_media_items.js)
// We should gradually transition to using this as time permits and we can take the time to validate funtionality
var PatronTitleStatus =
/*#__PURE__*/
function (_Backbone$Model) {
  _inherits(PatronTitleStatus, _Backbone$Model);

  function PatronTitleStatus() {
    _classCallCheck(this, PatronTitleStatus);

    return _possibleConstructorReturn(this, _getPrototypeOf(PatronTitleStatus).apply(this, arguments));
  }

  _createClass(PatronTitleStatus, [{
    key: "fetchTitleStatus",
    value: function fetchTitleStatus(titleCollection) {
      var statusTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var titleArray = titleCollection.models || titleCollection || [];

      if (titleArray.length === 0) {
        return Promise.resolve();
      }

      var titleIds = _.map(_(titleArray).pluck('id'), Number);

      this.request = this.fetch({
        data: JSON.stringify({
          titleIds: titleIds,
          statusTypes: statusTypes
        }),
        type: 'POST',
        contentType: 'application/json'
      });
      return this.request;
    }
    /** @param {Title} title */

  }, {
    key: "updateTitleState",
    value: function updateTitleState(title) {
      title.updatePatronState(this.attributes);
    }
  }, {
    key: "updateTitleCollectionState",

    /** @param {TitleCollection} titleCollection */
    value: function updateTitleCollectionState(titleCollection) {
      var _this = this;

      // we provide an empty array for any status attributes that were not fetched
      // in order to avoid breaking anything downstream
      this.stubAttributes();
      this.titleIds.forEach(function (titleId) {
        var model = titleCollection.findWhere({
          id: titleId
        });

        if (model) {
          _this.updateTitleState(model);
        }
      });
    }
  }, {
    key: "stubAttributes",
    value: function stubAttributes() {
      if (!this.get('onReadingHistory')) {
        this.set('onReadingHistory', []);
      }

      if (!this.get('starRatings')) {
        this.set('starRatings', []);
      }

      if (!this.get('onCheckouts')) {
        this.set('onCheckouts', []);
      }

      if (!this.get('onHolds')) {
        this.set('onHolds', []);
      }

      if (!this.get('onWishlist')) {
        this.set('onWishlist', []);
      }

      if (!this.get('recommendedToLibrary')) {
        this.set('recommendedToLibrary', []);
      }
    }
  }, {
    key: "url",
    get: function get() {
      return window.url(window.routes.mediaInfo);
    }
  }, {
    key: "titleIds",
    get: function get() {
      return _.union(this.get('onReadingHistory'), _.keys(this.get('starRatings')), this.get('onCheckouts'), this.get('onHolds'), this.get('onWishlist'), this.get('recommendedToLibrary'));
    }
  }]);

  return PatronTitleStatus;
}(Backbone.Model);

exports["default"] = PatronTitleStatus;